'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NativeListener = require('./NativeListener');

var _NativeListener2 = _interopRequireDefault(_NativeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NativeListener2.default;